<script>
  import AppSwitch from '@/components/Switch';
  import FormInput from '@/components/Form/Input';
  import AlertCircle from '@/assets/alert-circle.svg';
  import AuthCheckbox from '@/components/Form/Checkbox';

  export default {
    components: {
      AppSwitch,
      FormInput,
      AlertCircle,
      AuthCheckbox,
    },

    data: () => ({
      cpf: '',
      cnpj: '',
      email: '',
      birth: '',
      selected: 0,
      password: '',
      foundation: '',
      political: false,
    }),

    computed: {
      switches () {
        return [
          'Pessoa Física', 'Pessoa Jurídica',
        ];
      },
    },
  };
</script>

<template>
  <form>
    <AppSwitch
      v-model="selected"
      :options="switches"
      />

    <template v-if="selected === 0">
      <FormInput
        floating
        type="text"
        label="CPF"
        v-model="cpf"
        />

      <FormInput
        floating
        type="text"
        v-model="birth"
        label="Data de nascimento"
        />
    </template>

    <template v-else>
      <FormInput
        floating
        type="text"
        label="CNPJ"
        v-model="cnpj"
        />

      <FormInput
        floating
        type="text"
        v-model="foundation"
        label="Data de fundação"
        />
    </template>

    <FormInput
      floating
      type="text"
      label="Email"
      v-model="email"
      />

    <FormInput
      floating
      label="Senha"
      type="password"
      v-model="password"
      />

    <AuthCheckbox
      v-model="political"
      v-if="selected === 0"
      >
      Sou politicamente exposto <AlertCircle class="form-checkbox__icon" />
    </AuthCheckbox>

    <button class="auth__action">
      Cadastrar
    </button>
  </form>
</template>
